var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlasticBowl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32.001,
    viewBox: "0 0 32 32.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(-944 -839)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentcolor",
    id: "Line",
    transform: "translate(942 837.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M60.33,53h0v.13a.28.28,0,0,0,0-.13Zm0,0h0v.13a.28.28,0,0,0,0-.13Z",
    transform: "translate(-40.385 -35.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M33.274,17.689a8.136,8.136,0,0,0,.092-1.231,8.308,8.308,0,0,0-14.154-5.868,8.2,8.2,0,0,0-3.058-.575,8.308,8.308,0,0,0-1.914.222L11.215,2.375V2.348a.615.615,0,0,0-1.126.5l3.351,7.625h0a.231.231,0,0,0-.052-.092l-6.6-8.126-.015-.022a.616.616,0,0,0-.923.815l6.834,7.726a8.268,8.268,0,0,0-.874.458,8.246,8.246,0,0,0-8.049,6.46H2V18.3A12,12,0,0,0,10.923,29.9v1.64c0,1.428.615,2.462,1.5,2.462H23.582c.868,0,1.5-1.034,1.5-2.462V29.9A12,12,0,0,0,34,18.3v-.615ZM25.077,9.4a7.077,7.077,0,0,1,7.058,7.055,6.81,6.81,0,0,1-.108,1.231H31.012a6.071,6.071,0,0,0-9.769-5.938,8.47,8.47,0,0,0-.852-.578A7.077,7.077,0,0,1,25.077,9.4Zm0,3.222a3.834,3.834,0,0,0-2.255.735,7.3,7.3,0,0,0-.643-.766,4.775,4.775,0,0,1,2.9-.966,4.84,4.84,0,0,1,4.674,6.062H28.708a3.757,3.757,0,0,0,.2-1.231,3.843,3.843,0,0,0-3.834-3.834Zm2.6,3.834a2.575,2.575,0,0,1-.308,1.231H24.431a8.234,8.234,0,0,0-.954-3.289,2.585,2.585,0,0,1,1.6-.548,2.615,2.615,0,0,1,2.6,2.606ZM14.631,11.409a7.034,7.034,0,0,1,1.538-.166,6.938,6.938,0,0,1,2.948.646,6.822,6.822,0,0,1,1.745,1.138A7,7,0,0,1,23.2,17.689h-1a6.074,6.074,0,0,0-6.043-5.449h-.338a8.209,8.209,0,0,0-1.363-.588c-.12-.04-.24-.077-.363-.111C14.268,11.5,14.449,11.449,14.631,11.409Zm5.323,6.32v-.04a7.255,7.255,0,0,0-.252-.88l-.025-.043h0a3.837,3.837,0,0,0-4.348-2.2,5.908,5.908,0,0,0-1.194-.649,4.889,4.889,0,0,1,1.609-.425h.415a4.84,4.84,0,0,1,4.8,4.2H19.948a.086.086,0,0,1,.006.04Zm-1.28-.04h-1.04a5.889,5.889,0,0,0-1.055-1.96,2.637,2.637,0,0,1,1.96,1.514c.037.111.074.222.1.332C18.655,17.612,18.665,17.649,18.674,17.689Zm-5.015-1.538a3.837,3.837,0,0,0-5.172,1.538H7.378A4.834,4.834,0,0,1,11.846,14.7a5.471,5.471,0,0,1,.683.043.265.265,0,0,0,.052,0,4.849,4.849,0,0,1,3.745,2.948h-1.1A3.852,3.852,0,0,0,13.658,16.151Zm.034,1.538H10a2.606,2.606,0,0,1,3.692,0ZM8.249,13.443a7.917,7.917,0,0,1,3.6-.985,7.9,7.9,0,0,1,1.028.077,7.077,7.077,0,0,1,.874.188,6.068,6.068,0,0,0-1.286.772c-.2-.018-.4-.028-.615-.028a6.065,6.065,0,0,0-5.772,4.222H5.028a7.009,7.009,0,0,1,3.222-4.246ZM22,29.074H17.385V30.3h6.462v1.231a1.929,1.929,0,0,1-.308,1.231H12.462a1.929,1.929,0,0,1-.308-1.231V30.3h1.538V29.074A10.769,10.769,0,0,1,3.249,18.92h29.5A10.769,10.769,0,0,1,22,29.074Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M60.35,53.13V53a23.579,23.579,0,0,0-.82-2.86,11.3,11.3,0,0,1,.8,2.86.28.28,0,0,1,.02.13Z",
    transform: "translate(-40.145 -34.318)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 4,
    height: 4,
    rx: 2,
    transform: "translate(13.76 17.957)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlasticBowl);
export default __webpack_public_path__ + "static/media/plasticBowl.6705cc89cdf0329afdbfc9125d77b3e7.svg";
export { ForwardRef as ReactComponent };